export const environment = {
  production: true,
  apiUrl: "https://api.jidvei.ro",
  clubUrl: "https://club.jidvei.ro",
  staffUrl: "https://staff.jidvei.ro",
  sentryDsnClub: "https://44a7c33acf0103c54ef5fa0e9705ce48@o4511765998534656.ingest.de.sentry.io/4511766038904912",
  sentryEnvironment: "production",
};
